//
//
//
//
//
//
//
//
//
//


// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };

import "./awaitReplyModel.less"
export default {
    name: "awaitReplyModel",
    props: {
        // src:String,
        // poster:String,
        // onPlayerReady:Function,
        // options: {
        //     type: Object,
        //     default() {
        //         return {};
        //     }
        // }
    },
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    beforeDestroy() {
       
    },
    methods:{
        
    },
    watch:{
       
    }
}



// WEBPACK FOOTER //
// ./src/myComponents/awaitReplyModel/awaitReplyModel.vue